import { useEffect, useState } from 'react'

import { cn } from '@gto/ui/cn'
import { PhotoIcon } from '@gto/ui/icons/outline'

export type ImageWithPlaceholderProps = {
  src: string | null
  alt: string
  placeholderWrapperClassName?: string
}

export const ImageWithPlaceholder = ({
  src,
  alt,
  placeholderWrapperClassName,
}: ImageWithPlaceholderProps) => {
  const [error, setError] = useState(false)
  useEffect(
    function loadPlaceholderImage() {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- imperative image preload, not derived state: constructs an Image() and subscribes to its onload/onerror to decide between the real <img> and the placeholder before the visible <img> mounts (avoids a broken-image flash). There is no React event for "a preloaded Image finished decoding"; react.md:17 blesses effects for exactly this imperative-DOM/subscription shape. The `src === null` case needs no setState — the render already branches on `src === null`.
      if (src === null) {
        return
      }
      const img = new Image()

      img.src = src
      img.onload = () => {
        setError(false)
      }
      img.onerror = () => {
        setError(true)
      }
    },
    [src],
  )

  return (
    <>
      {error || src === null ? (
        <div className={cn('flex items-center justify-center p-4', placeholderWrapperClassName)}>
          <PhotoIcon
            color="inherit"
            height={32}
            width={32}
          />
        </div>
      ) : (
        <img
          alt={alt}
          className="block h-auto w-full"
          loading="lazy"
          src={src}
        />
      )}
    </>
  )
}
